import accountRecoveryConfirmPasswordMessagesTemplate from "./messages/accountRecoveryConfirmPasswordMessagesTemplate";
import accountRecoveryPasswordMessagesTemplate from "./messages/accountRecoveryPasswordMessagesTemplate";

const accountRecoveryErrorMessagesTemplate = `
<a href="#" id="screenReader" ng-click="enableScreenReaderErrors($event)" class="sr-only">There were {{accountRecoveryForm.$error.required.length}} errors in the information you submitted. Review errors.</a>
<div id="screenReaderErrorMessages" class="sr-only">
  <!-- Password -->
  <a ng-if="displayFieldMessages('password')" href="#" ng-click="focusOnErrorInput($event, 'acPasswordInput')">${accountRecoveryPasswordMessagesTemplate} Focus invalid input.</a>
  <!-- Confirm Password -->
  <a ng-if="displayFieldMessages('confirmPassword')" href="#" ng-click="focusOnErrorInput($event, 'confirmPasswordInput')">${accountRecoveryConfirmPasswordMessagesTemplate} Focus invalid input.</a>
</div>
`;
export default accountRecoveryErrorMessagesTemplate;
